<template>
    <div class="or-main-title">
        <div class="layout-1200">
            <div class="content">
                <h1 class="title">{{info ? info['main-title'] : null}}</h1>
                <div ref="description" class="text"></div>
                <div class="buttons flex-row row-ver-center row-space-between">
                    <or-button @click="toFeedback('name')" :options="{
                                    text: 'Связаться с нами',
                                    class: 'fill-button',
                                    style: {
                                        width: '240px',
                                        height: '60px',
                                        borderRadius: '8px',
                                    },
                                    animation: 'anim-main-button'
                                }"/>
                    <or-button @click="redirect('production')" :options="{
                                        text: 'Продукция',
                                        class: 'stroke-button',
                                        style: {
                                            width: '240px',
                                            height: '60px',
                                            borderRadius: '8px',
                                        },
                                        animation: 'anim-sub-button'
                                     }"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import orButton from "../../../global/or-button.vue"
export default {
    components: {orButton},
    computed: {
        ...mapGetters({info: 'getInfo'})
    },
    mounted() {
        const i = setInterval(()=>{
            if (this.info) {
                clearInterval(i);
                this.convertText({text: this.info.description, container: this.$refs.description})
            }
        },100)
    },
    methods: {
        ...mapActions({convertText: 'convertText', changePage: 'changePage'}),
        redirect(url) {
            this.changePage({page: url});
        },
        toFeedback(focus, fill) {
            const i = setInterval(()=>{
                let f = document.getElementById('feedback');
                if (f) {
                    window.scrollTo(0, f.offsetTop);
                    clearInterval(i)
                    this.feedback_settings = {focus};
                }
            },10);
        }
    }
}
</script>

<style scoped>
    .or-main-title {
        width: 100vw;
        min-width: 1200px;
        /* max-width: 100%; */
        height: 600px;
        background-image: url('../../../../assets/main-title-bg.jpg');
        background-position: center;
        background-size: cover;
    }
    .content {
        position: absolute;
        top: 168px;
    }
    .title {
        text-align: left;
        font-size: 60px;
        line-height: 70px;
        color: #EBB932;
        margin-bottom: 30px;
    }
    .text {
        text-align: left;
        font-size: 20px;
        line-height: 23px;
        color: #FFFFFF;
        margin-bottom: 60px;
    }
    .buttons {
        width: 510px;
    }
</style>